import { cva, type VariantProps } from "class-variance-authority";
import type { HTMLAttributes, ReactNode } from "react";
import { cn } from "@/lib/cn";

const alertVariants = cva("rounded-lg border px-4 py-3 text-sm", {
  variants: {
    variant: {
      info: "border-primary/20 bg-primary/5 text-fg",
      success: "border-success/20 bg-success/10 text-fg",
      warning: "border-warning/30 bg-warning/10 text-fg",
      danger: "border-danger/20 bg-danger/10 text-fg",
    },
  },
  defaultVariants: {
    variant: "info",
  },
});

type AlertProps = HTMLAttributes<HTMLDivElement> &
  VariantProps<typeof alertVariants> & {
    title?: string;
    children?: ReactNode;
  };

export function Alert({ className, variant, title, children, ...props }: AlertProps) {
  return (
    <div role="alert" className={cn(alertVariants({ variant }), className)} {...props}>
      {title ? <p className="mb-1 font-medium">{title}</p> : null}
      {children}
    </div>
  );
}
